export default class MappingModel {
  input: string = null;
  output: string = null;
}
